var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.041,
    height: 24.041,
    viewBox: "0 0 24.041 24.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M21.347,20.04,18.3,16.995l3.046-3.046a.924.924,0,1,0-1.306-1.306L17,15.689,13.95,12.643a.924.924,0,1,0-1.306,1.306l3.046,3.046L12.644,20.04a.893.893,0,0,0,0,1.306.917.917,0,0,0,1.306,0L17,18.3l3.046,3.046a.928.928,0,0,0,1.306,0A.917.917,0,0,0,21.347,20.04Z",
    transform: "translate(-1.6 -1.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M15.4,4.993A10.4,10.4,0,1,1,8.039,8.039,10.334,10.334,0,0,1,15.4,4.993m0-1.618A12.021,12.021,0,1,0,27.416,15.4,12.019,12.019,0,0,0,15.4,3.375Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/Close-circle.0c2a57fcc5e7faa573bbb7574134e28b.svg";
export { ForwardRef as ReactComponent };